import { render, staticRenderFns } from "./ModuleSetting.vue?vue&type=template&id=50478650&scoped=true&"
import script from "./ModuleSetting.vue?vue&type=script&lang=js&"
export * from "./ModuleSetting.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSetting.vue?vue&type=style&index=0&id=50478650&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50478650",
  null
  
)

export default component.exports